import { render, staticRenderFns } from "./reminderArchive.vue?vue&type=template&id=9a825b14&"
import script from "./reminderArchive.vue?vue&type=script&lang=js&"
export * from "./reminderArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports